<template>
  <div>
    <div v-if="showSpinner" class="loader-wrapper">
      <div class="loader"></div>
    </div>
    <b-row class="mt-2 d-flex flex-nowrap menu-2">
      <b-col cols="auto" class="pt-1">
          <div class="d-flex flex-row justify-content-start">
            <div class="w-50">
              <b-form-group label="Portfolio" label-for="portfolio_select" label-class="font-weight-bold" class="text-left">
                <b-form-row>
                  <b-form-select
                    id="portfolio_select"
                    v-model="selectedPortfolio"
                    @change="changeSelectedPortfolio"
                    :disabled="portfolios.length == 0">
                    <option v-for="portfolio of portfolios" :key="portfolio.Name" :value="portfolio.Name">{{ portfolio.Name }}</option>
                  </b-form-select>
                </b-form-row>
              </b-form-group>
            </div>
            <div class="pl-3 w-50">
              <b-form-group label="Scenario" label-for="vendor_select" label-class="font-weight-bold" class="text-left">
                <b-form-row class="d-flex flex-column">
                  <div class="flex-row">
                    <b-form-select id="vendor_select" v-model="selectedVendor" @change="changeSelectedVendor">
                      <template v-slot:first>
                        <b-form-select-option :value="null" disabled>Select vendor</b-form-select-option>
                      </template>
                      <option :value="'All'">All</option>
                      <option :value="'Default'">Not vendor specific</option>
                      <b-form-select-option v-for="vendor of vendors" :key="vendor" :value="vendor">{{ vendor }}</b-form-select-option>
                    </b-form-select>
                  </div>
                  <div class="pt-1">
                    <b-form-checkbox
                      style="display: inline-block"
                      id="generic_checkbox" v-model="useGenericScenarios" @change="changeUseGenericScenarios"/>
                    <span class="parameters-label">Global</span>
                  </div>
                </b-form-row>
              </b-form-group>
            </div>
          </div>
      </b-col>
      <b-col cols="6" class="pt-1 mr-2">
        <b-form-group label="Parameters" label-for="settlement_date" label-class="font-weight-bold" class="text-left">
          <div class="d-flex flex-row">
            <b-form-row class="d-flex flex-column">
              <div>
                <span class="parameters-label">Settlement date</span>
                <datepicker
                  id="settlement_date"
                  :clearable="false"
                  class="parameters-content"
                  input-class="form-control text-right calculation-settings-input"
                  type="date"
                  format="MM/DD/YYYY" lang="en"
                  v-model="settlementDate"
                  @change="changeSettlementDate"
                />
              </div>
              <!--
                          <div v-if='portfolioType == "Reinsurance"' class="pt-1">
                            <span class="parameters_label">Reinsurance Interest (%)</span>
                            <b-form-input v-model="interestRate" class="parameters_content calculation-settings-input text-right" @change="changeInterestRate"/>
                          </div>
              -->
              <div class="pt-1" v-if='portfolioType != "Reinsurance"'>
                <span class="parameters-label">Libor Index (%)</span>
                <b-form-input v-model="libor" class="parameters-content calculation-settings-input text-right" @change="changeLibor"/>
              </div>
              <!--
              <div class="pt-1">
                <span class="parameters_label">Mod (%)</span>
                <b-form-input v-model="modPct" style="width: 50%;" class="parameters_content calculation-settings-input text-right"/>
              </div>
              <div class="pt-1">
                <span class="parameters-label">Shift Months</span>
                <b-form-input
                  v-model="settlementDateMonthsBackAdjustment"
                  class="parameters-content calculation-settings-input text-right"
                  @change="changeSettlementDateMonthsBackAdjustment"
                  :formatter="formatInteger"
                />
              </div>
              -->
              <div class="pt-1">
                <span class="parameters-label">Early Call</span>
                <b-form-checkbox id="call_checkbox" v-model="earlyCall" class="parameters-content" @change="changeEarlyCall"/>
              </div>
            </b-form-row>
            <b-form-row class="d-flex flex-column" style="padding-left: 2rem">
              <div class="text-left">
                <b-form-checkbox
                  id="export_scenarios_checkbox"
                  v-model="useExportScenarios"
                  @change="changeExportScenarios"
                >
                  Export Scenario Cashflows to Excel
                </b-form-checkbox>
              </div>
              <div class="text-left">
                <b-form-checkbox
                  id="export_scenarios_csv_checkbox"
                  v-model="useExportScenariosToCsv"
                  @change="changeExportScenariosToCsv"
                >
                  Export Tranche Level Cashflows
                </b-form-checkbox>
              </div>
              <div class="text-left" v-if="this.$store.getters.isAdmin">
                <b-form-checkbox
                  id="calculate_cashflows_checkbox"
                  v-model="useCalcCashflows"
                  @change="changeCalcCashflows"
                >
                  Export Cashflows to Database
                </b-form-checkbox>
                <span class="text-danger" v-if="isSavingCalcCashflows">Calculating...</span>
              </div>
              <div class="text-left">
                <b-btn
                  variant="primary"
                  style="width: 115px; min-height: 35px;"
                  class="text-nowrap mr-1 mt-2"
                  :disabled="portfolioEntries.length == 0 || scenariosNames.length == 0"
                  @click="exportScenariosCashflowsToExcel"
                >Run Scenarios</b-btn>
                <b-btn
                  style="width: 115px; min-height: 35px;"
                  variant="info"
                  @click="exportToExcel"
                  :disabled="!areResultsGenerated"
                  class="text-nowrap mr-1 mt-2"
                >Export Metrics</b-btn>
                <hide-scenarios
                  :disabled="flatScenarios.length === 0"
                  :scenarios="flatScenarios"
                  @select="onHideScenariosSelected"
                />
              </div>
            </b-form-row>
          </div>
        </b-form-group>
      </b-col>
    </b-row>
    <b-form-group label=" ">
      <b-form-radio-group v-model="selectedResult" name="radio-inline">
        <b-form-radio value="RateOnLine">{{ portfolioType == 'Reinsurance' ? 'Rate On Line' : 'WAL' }}</b-form-radio>
        <b-form-radio value="LossOnLine">{{ portfolioType == 'Reinsurance' ? 'Loss On Line' : 'Write Down' }}</b-form-radio>
        <b-form-radio value="ReturnOnLine">{{ portfolioType == 'Reinsurance' ? 'Margin On Line' : 'Spread' }}</b-form-radio>
        <b-form-radio value="CollateralLossesPct">Ref Pool Loss Pct</b-form-radio>
        <b-form-radio value="Yield">{{ portfolioType == 'Reinsurance' ? 'ROI' : 'Yield' }}</b-form-radio>
      </b-form-radio-group>
    </b-form-group>
    <table class="table table-sm color mb-2" v-if="portfolioEntries.length > 0">
      <thead>
        <col>
        <col>
        <col>
        <col>
        <col>
        <col>
        <col  v-for="(scenario) in scenariosToShow" :key="scenario.name">
        <tr v-if="scenariosToShow && scenariosToShow.length > 0">
          <th scope="col" colspan="6" ></th>
          <th v-for="(scenario) in scenariosToShow" :key="scenario.name">
            <span>{{scenario.vendor}}</span>
          </th>
        </tr>
        <tr>
          <th></th>
          <th style="min-width: 130px">Deal</th>
          <th>Bond</th>
          <th class="text-right" style="min-width: 110px">
            <span>{{ portfolioType == 'Reinsurance' ? 'Initial Limit ($)' : 'Balance ($)' }}</span>
          </th>
          <th class="text-right" style="min-width: 90px">
            <span>{{ portfolioType == 'Reinsurance' ? 'Current Limit ($)' : 'Current Balance ($)' }}</span>
          </th>
          <th class="text-right" style="min-width: 65px">
            <span>{{ portfolioType == 'Reinsurance' ? 'Coll (%)' : 'Price ($)' }}</span>
          </th>
          <th v-for="(scenario, index) in scenariosToShow" :key="scenario.name" @click="runTotalsPerScenario(index)" class="color_hover" >
            {{ scenario.name }}
          </th>
        </tr>
      </thead>
      <tbody>
      <vendor-grid-entry
          v-for="(portfolioEntry, index) in portfolioEntries"
          :key="index"
          :entry="portfolioEntry"
          :index="index"
          :selectedResultType="selectedResult"
          :scenariosNames="scenariosToShow"
          @selected="getCashFlows"
      />
      </tbody>
      <tfoot>
      <tr>
        <th>Totals</th>
        <td></td>
        <td></td>
        <td class="text-right">{{ totalOwnedFaceAtm | dollarValue(0) }}</td>
        <td class="text-right">{{ currentBalanceTotal | dollarValue(0) }}</td>
        <td></td>
      </tr>
      </tfoot>
    </table>
    <b-tabs v-if="showTotalsPerScenarioTables">
      <b-tab title="ACIS" v-if="portfolioType == 'Reinsurance' && acisPortfolioCashflow.length > 0" :active="acisPortfolioCashflow.length > 0">
        <b-btn @click="exportPerScenarioTableToExcel('ACIS', 'acisTotalCashflow')" variant="info" class="float-left mt-2 mb-2">
          Export Cashflow to Excel
        </b-btn>
        <acis-cashflow
            :acisCashflow="acisPortfolioCashflow"
            :totals="acisTotals"
            :scenarioName="cashflowScenarioName"
            isPortfolio
            :isReinsurancePortfolio="isReinsurancePortfolio"
            ref="acisTotalCashflow"
        />
      </b-tab>
      <b-tab
          title="CIRT" v-if="portfolioType == 'Reinsurance' && cirtPortfolioCashflow.length > 0"
          :active="acisPortfolioCashflow.length == 0 && cirtPortfolioCashflow.length > 0"
      >
        <b-btn @click="exportPerScenarioTableToExcel('CIRT', 'cirtTotalCashflow')" variant="info" class="float-left mt-2 mb-2">
          Export Cashflow to Excel
        </b-btn>
        <cirt-cashflow
            :cashflow="cirtPortfolioCashflow"
            :totals="cirtTotals"
            :scenarioName="cashflowScenarioName"
            dealName=""
            isPortfolio
            :isReinsurancePortfolio="isReinsurancePortfolio"
            ref="cirtTotalCashflow"
        />
      </b-tab>
      <b-tab title="Bonds" v-if="bondPortfolioCashflow.length > 0">
        <b-btn @click="exportPerScenarioTableToExcel('Bonds', 'bondsTotalCashflow')" variant="info" class="float-left mt-2 mb-2">
          Export Cashflow to Excel
        </b-btn>
        <bond-cashflow
            :bond="bondPortfolioCashflow"
            :isPortfolio="true"
            :scenarioName="cashflowScenarioName"
            v-if="bondPortfolioCashflow.length > 0"
            ref="bondsTotalCashflow"
        />
      </b-tab>
      <b-tab title="Totals" v-if="acisPortfolioCashflow.length > 0 && cirtPortfolioCashflow.length > 0">
        <b-btn @click="exportPerScenarioTableToExcel('ACIS&CIRT', 'totalCashflow')" variant="info" class="float-left mt-2 mb-2">
          Export Cashflow to Excel
        </b-btn>
        <acis-cashflow
            :acisCashflow="totalPortfolioCashflow"
            :totals="totalTotals"
            :scenarioName="cashflowScenarioName"
            dealName=""
            bondName=""
            isTotal
            ref="totalCashflow"
            :isReinsurancePortfolio="isReinsurancePortfolio"
        />
      </b-tab>
    </b-tabs>
    <b-row class="mb-2 mt-2 ml-0">
      <b-btn
          v-if="acisPortfolioCashflow.length + cirtPortfolioCashflow.length + bondPortfolioCashflow.length > 0  && !showTotalsPerScenario"
          @click="exportCashflowToExcel()"
          :disabled="!areResultsGenerated"
          variant="info"
          class="float-left"
      >
        Export Cashflow to Excel
      </b-btn>
    </b-row>
    <acis-cashflow
        v-if="acisPortfolioCashflow.length > 0 && !showTotalsPerScenario"
        ref="acisCashflow"
        :acisCashflow="acisPortfolioCashflow"
        :miscVariables="acisMiscVariables"
        :totals="acisTotals"
        isPortfolio
        :isReinsurancePortfolio="isReinsurancePortfolio"
        isMatrixClicked
        :scenarioName="cashflowScenarioName"
        :dealName="cashflowDealName"
        :bondName="cashflowBondName"
    />
    <cirt-cashflow
        v-if="cirtPortfolioCashflow.length > 0 && !showTotalsPerScenario"
        ref="cirtCashflow"
        :cashflow="cirtPortfolioCashflow"
        :miscVariables="cirtMiscVariables"
        :totals="cirtTotals"
        isPortfolio
        :isReinsurancePortfolio="isReinsurancePortfolio"
        isMatrixClicked
        :scenarioName="cashflowScenarioName"
        :dealName="cashflowDealName"
    />
    <bond-cashflow
        v-if="bondPortfolioCashflow.length > 0 && !showTotalsPerScenario"
        ref="bondCashflow"
        :bond="bondPortfolioCashflow"
        :miscVariables="bondMiscVariables"
        :isPortfolio="true"
        :isReinsurancePortfolio="isReinsurancePortfolio"
        :isMatrixClicked="true"
        :scenarioName="cashflowScenarioName"
        :dealName="cashflowDealName"
        :bondName="cashflowBondName"
    />
  </div>
</template>

<script>
import service                    from '../../services/HttpRequestService';
import { convertToPctArray }        from '@/utilities/ArrayUtils';
import formatter                  from '../../utilities/Formatter';
import Datepicker                 from 'vue2-datepicker';
import moment                     from 'moment';
import AcisCashflow               from '../acis/Cashflow';
import CirtCashflow               from '../cirt/Cashflow';
import BondCashflow               from '../dealAnalysis/BondCashflow';
import { toMatrix as acisToMatrix } from '../acis/utils';
import { toMatrix as cirtToMatrix } from '../cirt/utils';
import { toMatrix as bondToMatrix } from '../dealAnalysis/utils';
import ManagePortfoliosModal      from './ManagePortfoliosModal';
import SaveAsModal                from './SaveAsModal';
import VendorGridEntry            from './VendorGridEntry';
import HideScenarios              from './HideScenarios';
import Scenario                   from '../scenario';
import naturalSort                from 'javascript-natural-sort';
// import * as Excel                 from 'exceljs';
import FileSaver                  from 'file-saver';
import excelSupport               from '../../utilities/ExcelSupport';
import { BOND_PAID_OFF, TRACE_ERROR } from '@/constants';
import UtilsData                  from '@/utilities/UtilsData';
import ObjAlertState              from '@/components/common/alert/ObjAlertState';

const SELECTED_SCENARIOS = 'selectedScenarios';
export default {
  data() {
    return {
      settlementDate: new Date(),
      interestRate: 0.0,
      modPct: 0.0,
      libor: 0.0,
      selectedPortfolio: '',
      portfolios: {},
      selectedVendor: null,
      useGenericScenarios: false,
      useExportScenarios: false,
      useCalcCashflows: false,
      useExportScenariosToCsv: false,
      isSavingCalcCashflows: false,
      vendors: [],
      portfolioCashflow: [],
      acisPortfolioCashflow: [],
      acisMiscVariables: [],
      cirtPortfolioCashflow: [],
      cirtMiscVariables: [],
      bondPortfolioCashflow: [],
      bondMiscVariables: [],
      totalPortfolioCashflow: [],
      showSpinner: true,
      scenarios: new Map(),
      savedScenariosToHide: {},
      scenariosNames: [],
      flatScenarios: [],
      unsavedChanges: false,
      selectedResult: 'RateOnLine',
      resultOptions: [
        { text: 'Rate On Line', value: 'RateOnLine' },
        { text: 'Loss On Line', value: 'LossOnLine' },
        { text: 'Margin On Line', value: 'ReturnOnLine' },
        { text: 'ROI', value: 'Yield' }
      ],
      scenariosSize: 0,
      selectedScenario: {},
      selectedEntry: {},
      runDate: null,
      cashflowScenarioName: '',
      cashflowDealName: '',
      cashflowBondName: '',
      earlyCall: false,
      acisTotals: {},
      cirtTotals: {},
      bondTotals: {},
      totalTotals: {},
      showTotalsPerScenario: true,
      cirtCashflowPerScenario: {},
      settlementDateMonthsBackAdjustment: 2
    };
  },
  computed: {
    scenariosToShow() {
      return this.flatScenarios.filter(x => !x.hidden);
    },
    totalOwnedFaceAtm() {
      let total = this.portfolioEntries.map(x => Number(x.OwnedFaceAmt)).reduce((x, y) => x + y, 0);
      return total;
    },
    showTotalsPerScenarioTables: function () {
      return (
        this.acisPortfolioCashflow.length +
        this.cirtPortfolioCashflow.length +
        this.bondPortfolioCashflow.length >
        0 && this.showTotalsPerScenario
      );
    },
    portfolioEntries: function () {
      if (this.portfolios.hasOwnProperty(this.selectedPortfolio)) {
        return this.portfolios[this.selectedPortfolio].PortfolioEntries;
      }
      return [];
    },
    areResultsGenerated: function () {
      return this.portfolioEntries.some(entry => {
        return (entry.Results && Object.entries(entry.Results).length !== 0)
      });
    },
    cirtActivityMonth: function () {
      let settlementDate = moment(this.settlementDate);
      let activityMonth = moment()
        .year(settlementDate.year())
        .month(settlementDate.month() - 2)
        .date(25);
      return activityMonth.format('MM/YYYY');
    },
    portfolioType: function () {
      return this.portfolios[this.selectedPortfolio]
        ? this.portfolios[this.selectedPortfolio].PortfolioType
        : null
    },
    isReinsurancePortfolio: function () {
      return (
        this.portfolios[this.selectedPortfolio] &&
          this.portfolios[this.selectedPortfolio].PortfolioType === 'Reinsurance'
      );
    },
    currentBalanceTotal: function () {
      if (this.portfolioEntries && this.portfolioEntries.length > 0) {
        const withCurrentBalance = this.portfolioEntries.filter(p => p.currentBalance);
        if (withCurrentBalance && withCurrentBalance.length > 0) {
          return formatter.formatDollarValue(
            withCurrentBalance.reduce((acc, curr) => acc + curr.currentBalance, 0)
          );
        }
      }
      return null;
    }
  },
  async created() {
    try {
      const listOfSavedScenarios = JSON.parse(this.$cookies.get(SELECTED_SCENARIOS)) || [];
      this.savedScenariosToHide = listOfSavedScenarios.reduce(
        (acc, name) => ({ ...acc, [name]: true }),
        {}
      );
    } catch (e) {}
    try {
      this.vendors = await service.getVendorsForAvailableUserScenariosAndCashflows();
    } catch (err) {
      await service.log(TRACE_ERROR, err.response.data ? err.response.data.Message : '', err.stack);
    }
    this.selectedPortfolio = this.$cookies.get('portfolio') || this.$store.getters.portfolioName;
    this.selectedVendor = this.$cookies.get('vendor') || 'All';
    this.useGenericScenarios = this.$cookies.get('useGenericScenarios') === 'true';
    this.useExportScenarios = this.$cookies.get('useExportScenarios') === 'true';
    this.useExportScenariosToCsv = this.$cookies.get('useExportScenariosToCsv') === 'true';
    this.settlementDate = this.$root.$data.settlementDate || new Date();
    this.earlyCall = this.$cookies.get('earlyCall') || false;
    this.libor = this.$cookies.get('libor') || 0.0;
    this.interestRate = this.$cookies.get('interestRate') || 0.0;
    this.scenarios = new Map();
    await this.loadPortfolios();
    this.$forceUpdate();
    if (
      this.$store.getters.portfolioResult.portfolioEntries &&
        this.$store.getters.portfolioResult.portfolioEntries.length
    ) {
      this.portfolios[this.selectedPortfolio]
        .PortfolioEntries = this.$store.getters.portfolioResult.portfolioEntries;
    }
    this.reloadScenariosOnChange(this.useGenericScenarios);
    this.showSpinner = false;
  },
  methods: {
    getTotalForScenario(scenarioIndex) {
      let result = null;
      for (let entry of this.portfolioEntries) {
        let entryResult = entry.Results[scenarioIndex][this.selectedResult].toString();
        if (
          !(
            this.portfolioType !== 'Reinsurance' &&
                (this.selectedResult === 'RateOnLine' || this.selectedResult === 'ReturnOnLine')
          )
        ) {
          entryResult = entryResult.substring(0, entryResult.length - 1);
        }
        entryResult = Number(entryResult);
        if (!Number.isNaN(entryResult)) {
          result == null ? (result = entryResult) : (result += entryResult);
        }
      }
      return this.formatTotalCell(result);
    },
    formatTotalCell(value) {
      if (value == null) {
        return '-----';
      }
      if (
        this.portfolioType !== 'Reinsurance' &&
          (this.selectedResult === 'RateOnLine' || this.selectedResult === 'ReturnOnLine')
      ) {
        return formatter.round(value, 2);
      }
      return formatter.formatPctValue(value / 100, 2);
    },
    async runTotalsPerScenario(scIndex) {
      this.showTotalsPerScenario = true;
      let listOfCellIndexes = [...Array(this.portfolioEntries.length).keys()].map(x => {
        return { entryIndex: x, scenarioIndex: scIndex };
      });
      await this.getCashFlowsFromCells(listOfCellIndexes, {
        preRequest: this.setCashflowPreRequestData,
        postRequest: this.resetCashflowData,
        handleData: this.setCashflowData
      });
    },
    async savePortfolioCalculation(saveOptions) {
      const currentPortfolio = this.portfolios[this.selectedPortfolio];
      if (!currentPortfolio) {
        return;
      }
      let settlementDate = moment(this.settlementDate);

      const requestBodyEntry = {
        PortfolioId: currentPortfolio.Id,
        InterestRate: this.interestRate / 100,
        EarlyCall: this.earlyCall,
        Vendor: this.selectedVendor,
        Libor: convertToPctArray(this.libor),
        SettlementDate: settlementDate.format('YYYYMMDD'),
        ScenarioNames: this.scenariosNames,
        Options: saveOptions,
        SettlementDateMonthsBackAdjustment: 2
        // SettlementDateMonthsBackAdjustment: parseInt(formatter.formatAsNumber(this.settlementDateMonthsBackAdjustment, 0) ?? 0, 10)
      };
      const isExportRequested = (1 << 1) & saveOptions;
      const actionVerbForMessages = isExportRequested ? 'export' : 'save';
      const actionVerbPast = actionVerbForMessages === 'export' ? 'exported' : 'saved';
      try {
        this.isSavingCalcCashflows = true;
        const response = await service.savePortfolioAnalysis(requestBodyEntry);
        if (isExportRequested && (!response || !response.data)) {
          throw new Error('Export operation has failed.');
        }
        ObjAlertState.set(`Portfolio calculation successfully ${actionVerbPast}.`, 0);
        const now = moment();
        const exportedPortfolioFileName =
                  `${currentPortfolio.Name || ''}` +
                  `${now.format('YYYYMMDD')}` +
                  ` at ${now.format('HHmmss')}` +
                  '.csv';
        if (UtilsData.isEmpty(response.data)) {
          return false;
        }
        FileSaver.saveAs(new Blob([response.data]), exportedPortfolioFileName);
      } catch (err) {
        const errMessage = `Failed to ${actionVerbForMessages} portfolio calculation. ` +
            `${err.response.data.Message}`;
        await service.log(TRACE_ERROR, errMessage, err.stack);
        ObjAlertState.set(errMessage, 3);
      } finally {
        this.isSavingCalcCashflows = false;
      }
      return false;
    },
    async exportScenariosCashflowsToExcel() {
      this.resetCashflowData();
      this.clearScenarios();
      this.showSpinner = true;
      const cashflowsByScenarios = {};
      const errors = [];
      const missingScenariosByDeals = this.portfolioEntries.reduce((acc, entry) => {
        const dealScenarios = this.scenarios.get(entry.DealName) || new Map();
        const missingScenarios = new Set(
          this.scenariosNames.filter(name => !dealScenarios.has(name))
        );
        acc[entry.DealName] = missingScenarios;
        return acc;
      }, {});
      const portfolioEntries = [...Array(this.portfolioEntries.length).keys()];
      this.portfolioEntries.forEach(entry => {
        if (missingScenariosByDeals[entry.DealName].size > 0) {
        }
      });
      const yieldErr = new Set();
      const promises = this.scenariosNames.map(async (name, i) => {
        const currentItems = portfolioEntries.map(x => ({ entryIndex: x, scenarioIndex: i }));
        const scenarioNum = i;
        const handlers = {
          handleMissingScenario: (entry, scenarioIndex, entryIndex) => {
            if (!entry.Results) {
              this.$set(entry, 'Results', []);
            }
            this.$set(entry.Results, scenarioIndex, {
              scenarioName: this.scenariosNames[scenarioIndex],
              Yield: 'Missing scenario',
              RateOnLine: 'Missing scenario',
              LossOnLine: 'Missing scenario',
              ReturnOnLine: 'Missing scenario',
              CollateralLossesPct: 'Missing scenario'
            });
          },
          preRequest: (entry, scenario, scenarioIndex, entryIndex) => {
            cashflowsByScenarios[scenario.ScenarioName] = {
              ScenarioName: scenario.ScenarioName,
              Vendor: scenario.Vendor
            };
          },
          postRequest: () => {},
          handleData: ({ res, ...data }) => {
            cashflowsByScenarios[name] = {
              ...(cashflowsByScenarios[name] || {}),
              ...data
            };
            this.portfolioEntries
              .filter(entry => !missingScenariosByDeals[entry.DealName].has(name))
              .forEach((portfolioEntry, entryIndex) => {
                let result = null;
                let resEntries = [];
                let resEntry = null;
                if (portfolioEntry.DealName.startsWith('ACIS')) {
                  resEntries = res.data.AcisPortfolio.PortfolioEntries;
                } else if (portfolioEntry.DealName.startsWith('CIRT')) {
                  resEntries = res.data.CirtPortfolio.PortfolioEntries;
                } else {
                  resEntries = res.data.BondPortfolio.PortfolioEntries;
                }
                resEntry = resEntries.find(item => {
                  const isBondNeeded = !portfolioEntry.DealName.startsWith('CIRT');
                  return (
                    item.DealName === portfolioEntry.DealName &&
                    (isBondNeeded ? item.BondName === portfolioEntry.BondName : true)
                  );
                });
                const collateralLossesPct = formatter.formatPctValueWithoutRounding(
                  resEntry.ProjectedLosses / resEntry.OriginalBalance || 0
                );
                let value = '-----';
                if (resEntry.Yield.IsSuccessful) {
                  value = formatter.formatPctValueWithoutRounding(resEntry.Yield.Value);
                } else {
                // TODO sk: remove after redesigning c++ message system
                  if (
                    resEntry.Yield.ErrorMessage !== "Can't compute Yield." &&
                    resEntry.Yield.ErrorMessage !== 'Too many tries in Yield calculation.' &&
                    resEntry.Yield.ErrorMessage !== 'Guess is too negative in Yield calculation.' &&
                    resEntry.Yield.ErrorMessage !== "Can't compute Spread." &&
                    resEntry.Yield.ErrorMessage !== 'Too many tries in Spread calculation.'
                  ) {
                    const message = `${i + 1}: ${resEntry.Yield.ErrorMessage}`;
                    if (resEntry.Yield.ErrorMessage !== BOND_PAID_OFF && !yieldErr.has(message)) {
                      yieldErr.add(message);
                      ObjAlertState.set(message, 3);
                    }
                  }
                }
                if (
                  portfolioEntry.DealName.startsWith('ACIS') ||
                  portfolioEntry.DealName.startsWith('CIRT')
                ) {
                  result = {
                    scenarioName: this.scenariosNames[scenarioNum],
                    Yield: value,
                    RateOnLine: formatter.formatPctValueWithoutRounding(
                      resEntry.LineMetrics.RateOnLine
                    ),
                    LossOnLine: formatter.formatPctValueWithoutRounding(
                      resEntry.LineMetrics.LossOnLine
                    ),
                    ReturnOnLine: formatter.formatPctValueWithoutRounding(
                      resEntry.LineMetrics.ReturnOnLine
                    ),
                    CollateralLossesPct: collateralLossesPct
                  };
                } else {
                  let spread = '-----';
                  if (resEntry.Spread.IsSuccessful) {
                    spread = resEntry.Spread.Value;
                  } else {
                  // TODO sk: remove after redesigning c++ message system
                    if (
                      resEntry.Spread.ErrorMessage !== "Can't compute Yield." &&
                      resEntry.Spread.ErrorMessage !== 'Too many tries in Yield calculation.' &&
                      resEntry.Spread.ErrorMessage !==
                      'Guess is too negative in Yield calculation.' &&
                      resEntry.Spread.ErrorMessage !== "Can't compute Spread." &&
                      resEntry.Spread.ErrorMessage !== 'Too many tries in Spread calculation.'
                    ) {
                      const message = `${i + 1}: ${resEntry.Spread.ErrorMessage}`;
                      if (resEntry.Yield.ErrorMessage !== BOND_PAID_OFF && !yieldErr.has(message)) {
                        yieldErr.add(message);
                        ObjAlertState.set(message, 3);
                      }
                    }
                  }
                  result = {
                    scenarioName: this.scenariosNames[scenarioNum],
                    Yield: value,
                    RateOnLine:
                                       resEntry.Characteristics.Wal != null ? resEntry.Characteristics.Wal : '-----',
                    LossOnLine:
                                       resEntry.Characteristics.WritedownPct != null
                                         ? formatter.formatPctValueWithoutRounding(
                                           resEntry.Characteristics.WritedownPct
                                         )
                                         : '-----',
                    ReturnOnLine: spread,
                    CollateralLossesPct: collateralLossesPct
                  };
                }
                if (!portfolioEntry.Results) {
                  this.$set(portfolioEntry, 'Results', []);
                }
                this.$set(portfolioEntry.Results, i, result);
                if (
                  !portfolioEntry.currentBalance ||
                  portfolioEntry.currentBalance !== resEntry.CurrentBalance
                ) {
                  this.$set(portfolioEntry, 'currentBalance', resEntry.CurrentBalance);
                }
              });
          },
          handleError: err => {
            if (err.response) {
              let entries = JSON.parse(err.response.config.data).Entries;
              let entryErrors = 'Error';
              if (err.response.data && err.response.data.Message && err.response.data.Message.split) {
                entryErrors = err.response.data.Message.split(', ');
              }
              let errMsg = this.buildErrorMessage(
                entryErrors,
                entries,
                entryIndex,
                missingScenarios
              );
              errors.push(errMsg);
            } else {
              errors.push(err.message);
            }
          }
        };
        return this.getCashFlowsFromCells(currentItems, handlers, { showSpinner: false });
      });
      try {
        await Promise.all(promises);
        if (this.useExportScenarios) {
          const dataset = Object.entries(cashflowsByScenarios).reduce((acc, [name, data]) => {
            const {
              acisPortfolioCashflow,
              totalPortfolioCashflow,
              cirtPortfolioCashflow,
              bondPortfolioCashflow,
              acisTotals,
              totalTotals,
              cirtTotals,
              Vendor
            } = data;
            const scenario = {
              ScenarioName: name,
              Vendor
            };
            const isSecondColumnShow =
                      (this.selectedPortfolio && this.isReinsurancePortfolio) || !this.selectedPortfolio;
            if (totalPortfolioCashflow && totalPortfolioCashflow.length) {
              const dealType = 'Totals';
              const matrix = acisToMatrix(totalPortfolioCashflow, totalTotals, isSecondColumnShow);
              acc.push({ scenario, dealType, matrix, totalTotals });
              return acc;
            }
            if (bondPortfolioCashflow && bondPortfolioCashflow.length) {
              const dealType = 'Bonds';
              const matrix = bondToMatrix(bondPortfolioCashflow);
              acc.push({ scenario, dealType, matrix });
              return acc;
            }
            if (acisPortfolioCashflow && acisPortfolioCashflow.length) {
              const dealType = 'ACIS';
              const matrix = acisToMatrix(acisPortfolioCashflow, acisTotals, isSecondColumnShow);
              acc.push({ scenario, dealType, matrix });
              return acc;
            }
            if (cirtPortfolioCashflow && cirtPortfolioCashflow.length) {
              const dealType = 'CIRT';
              const matrix = cirtToMatrix(cirtPortfolioCashflow, cirtTotals, isSecondColumnShow);
              acc.push({ scenario, dealType, matrix });
              return acc;
            }
            return acc;
          }, []);
          if (errors.length > 0) {
            ObjAlertState.set(errors.flat().join('<br>'), 3);
          }
          this.showSpinner = false;
          return excelSupport.exportMultiTotalCashflowsToExcel({
            userName: this.$store.getters.username,
            settlementDate: moment(this.settlementDate).format('YYYYMMDD'),
            runDate: this.runDate,
            portfolioName: this.selectedPortfolio,
            dataset,
            earlyCall: this.earlyCall
          });
        }
        const saveOptions = ((this.useCalcCashflows) ? 1 : 0) + ((this.useExportScenariosToCsv) ? 2 : 0);
        if (saveOptions > 0) {
          await this.savePortfolioCalculation(saveOptions);
        }
      } catch (err) {
        throw err;
      } finally {
        this.showSpinner = false;
      }
    },
    changeEarlyCall(newVal) {
      this.$cookies.set('earlyCall', newVal);
      this.earlyCall = newVal;
    },
    changeLibor(newVal) {
      this.$cookies.set('libor', newVal);
      this.libor = newVal;
    },
    changeInterestRate(newVal) {
      this.$cookies.set('interestRate', newVal);
      this.interestRate = newVal;
    },
    changeSettlementDate(newVal) {
      this.$root.$data.setSettlementDate(newVal);
      this.settlementDate = newVal;
    },
    changeSettlementDateMonthsBackAdjustment(newValue) {
      this.$cookies.set('settlementDateMonthsBackAdjustment', newVal);
      this.settlementDateMonthsBackAdjustment = newValue;
    },
    async setCashflowPreRequestData(entry, scenario, scenarioIndex) {
      this.selectedEntry = entry;
      this.selectedScenario = scenario;
      this.cashflowDealName = entry.DealName;
      this.cashflowBondName = entry.BondName;
      this.cashflowScenarioName = this.scenariosNames[scenarioIndex];
    },
    resetCashflowData() {
      this.acisPortfolioCashflow = [];
      this.cirtPortfolioCashflow = [];
      this.bondPortfolioCashflow = [];
      this.acisMiscVariables = [];
      this.cirtMiscVariables = [];
      this.bondMiscVariables = [];
      this.totalPortfolioCashflow = {};
    },
    setCashflowData(data) {
      if (data.acisPortfolioCashflow) {
        this.acisPortfolioCashflow = data.acisPortfolioCashflow;
        this.acisMiscVariables = (data.res && data.res.data.AcisPortfolio)
          ? data.res.data.AcisPortfolio.MiscVariables
          : null;
      }
      if (data.totalPortfolioCashflow) {
        this.totalPortfolioCashflow = data.totalPortfolioCashflow;
      }
      if (data.cirtPortfolioCashflow) {
        this.cirtPortfolioCashflow = data.cirtPortfolioCashflow;
        this.cirtMiscVariables = (data.res && data.res.data.CirtPortfolio)
          ? data.res.data.CirtPortfolio.MiscVariables
          : null;
      }
      if (data.bondPortfolioCashflow) {
        this.bondPortfolioCashflow = data.bondPortfolioCashflow;
        this.bondMiscVariables = (data.res && data.res.data.BondPortfolio)
          ? data.res.data.BondPortfolio.MiscVariables
          : null;
      }
      if (data.acisTotals) {
        this.acisTotals = data.acisTotals;
      }
      if (data.totalTotals) {
        this.totalTotals = data.totalTotals;
      }
      if (data.cirtTotals) {
        this.cirtTotals = data.cirtTotals;
      }
    },
    async getCashFlowsFromCells(
      listOfCells,
      { preRequest, postRequest, handleData, handleError, handleMissingScenario },
      { showSpinner = true } = {}
    ) {
      if (showSpinner) {
        this.showSpinner = true;
      }
      let requestBodyEntries = [];
      for (let cell of listOfCells) {
        let entryIndex = cell.entryIndex;
        let scenarioIndex = cell.scenarioIndex;
        let entry = this.portfolioEntries[entryIndex];
        // #####
        let dealScenarios;
        let scenario;
        // Deal-Specific scenario
        dealScenarios = this.scenarios.get(entry.DealName);
        if (dealScenarios) {
          scenario = dealScenarios.get(this.scenariosNames[scenarioIndex], undefined);
        }
        // // Deal-Common scenario
        if (!scenario) {
          dealScenarios = this.scenarios.get('');
          if (dealScenarios) {
            scenario = dealScenarios.get(this.scenariosNames[scenarioIndex], undefined);
          }
        }
        // #####
        if (scenario) {
          preRequest(entry, scenario, scenarioIndex, entryIndex);
          let ownedFaceAmt = 0;
          if (typeof entry.OwnedFaceAmt === 'string') {
            ownedFaceAmt = Number(entry.OwnedFaceAmt.toString().replace(/,/g, ''));
          } else {
            ownedFaceAmt = Number(entry.OwnedFaceAmt);
          }
          let settlementDate = moment(this.settlementDate);
          let body = {
            SettlementDate: settlementDate.format('YYYYMMDD'),
            DealName: entry.DealName,
            BondName: entry.BondName || null,
            OwnedFaceAmt: ownedFaceAmt,
            Margin: entry.Margin / 100,
            InterestRate: this.interestRate / 100,
            Balance: ownedFaceAmt,
            Price: entry.Margin,
            Cancellation: this.earlyCall,
            CancellationDate: entry.CancellationDate || null,
            CleanupCall: this.earlyCall,
            ModPct: this.modPct,
            SettlementDateMonthsBackAdjustment: 2
            // SettlementDateMonthsBackAdjustment: parseInt(formatter.formatAsNumber(this.settlementDateMonthsBackAdjustment, 0) ?? 0, 10)
          };
          if (scenario.hasOwnProperty('CollateralCashflow')) {
            Object.assign(body, {
              UserCollateralCashflow: scenario.CollateralCashflow
            });
          } else {
            Object.assign(body, {
              Cpr: convertToPctArray(scenario.Cpr),
              Cdr: convertToPctArray(scenario.Cdr),
              LossSeverity: convertToPctArray(scenario.LossSeverity),
              Delinquency: convertToPctArray(scenario.Delinquency),
              Libor: convertToPctArray(this.libor)
            });
          }
          requestBodyEntries.push(body);
        } else {
          handleMissingScenario && handleMissingScenario(entry, scenarioIndex, entryIndex);
        }
      }
      try {
        let body = {
          Entries: requestBodyEntries
        };
        let res = await service.runPortfolio(body);
        postRequest();
        this.runDate = new Date();
        let acisPortfolioCashflow = null;
        let totalPortfolioCashflow = null;
        let cirtPortfolioCashflow = null;
        let bondPortfolioCashflow = null;
        let acisTotals = null;
        let totalTotals = null;
        let cirtTotals = null;
        // copy pasted from portfolio; need to refractor
        if (res.data.AcisPortfolio) {
          const data = res.data.AcisPortfolio;
          acisPortfolioCashflow = formatter.formatDataInArray(
            data.PortfolioCashflow,
            [
              'RemainingLiability',
              'ReductionInLiability',
              'InsurerPaidLosses',
              'InsurancePremium',
              'CollateralTrustAccount',
              'CollateralAccountChange',
              'CollateralAccountInterest',
              'NetInsuranceCashflow',
              'CollateralBalance',
              'CollateralLosses'
            ],
            ['PaymentDate'],
            ['CprRate', 'CdrRate', 'LossSeverityRate', 'DelinquencyRate']
          );
          acisTotals = {
            ReductionInLiability: formatter.formatDollarValue(
              data.PortfolioCashflowTotals.ReductionInLiability
            ),
            InsurerPaidLosses: formatter.formatDollarValue(
              data.PortfolioCashflowTotals.InsurerPaidLosses
            ),
            InsurancePremium: formatter.formatDollarValue(
              data.PortfolioCashflowTotals.InsurancePremium
            ),
            CollateralLosses: formatter.formatDollarValue(
              data.PortfolioCashflowTotals.CollateralLosses
            ),
            NetInsuranceCashflow: formatter.formatDollarValue(
              data.PortfolioCashflowTotals.NetInsuranceCashflow
            )
          };
        }
        if (res.data.TotalPortfolio) {
          const data = res.data.TotalPortfolio;
          totalPortfolioCashflow = formatter.formatDataInArray(
            data.PortfolioCashflow,
            [
              'RemainingLiability',
              'ReductionInLiability',
              'InsurerPaidLosses',
              'InsurancePremium',
              'CollateralTrustAccount',
              'CollateralAccountChange',
              'CollateralAccountInterest',
              'NetInsuranceCashflow',
              'CollateralBalance',
              'CollateralLosses'
            ],
            ['PaymentDate'],
            ['CprRate', 'CdrRate', 'LossSeverityRate', 'DelinquencyRate']
          );
          totalTotals = {
            ReductionInLiability: formatter.formatDollarValue(
              data.PortfolioCashflowTotals.ReductionInLiability
            ),
            InsurerPaidLosses: formatter.formatDollarValue(
              data.PortfolioCashflowTotals.InsurerPaidLosses
            ),
            InsurancePremium: formatter.formatDollarValue(
              data.PortfolioCashflowTotals.InsurancePremium
            ),
            CollateralLosses: formatter.formatDollarValue(
              data.PortfolioCashflowTotals.CollateralLosses
            ),
            NetInsuranceCashflow: formatter.formatDollarValue(
              data.PortfolioCashflowTotals.NetInsuranceCashflow
            )
          };
        }
        if (res.data.CirtPortfolio) {
          const data = res.data.CirtPortfolio;
          cirtPortfolioCashflow = formatter.formatDataInArray(
            data.PortfolioCashflow,
            [
              'CollateralBalance',
              'CollateralLosses',
              'RemainingLiability',
              'ReductionInLiability',
              'InsurerPaidLosses',
              'InsurancePremium',
              'CollateralTrustAccount',
              'CollateralAccountChange',
              'CollateralAccountInterest',
              'NetInsuranceCashflow'
            ],
            [],
            ['CprRate', 'CdrRate', 'LossSeverityRate', 'DelinquencyRate']
          );
          for (var row of cirtPortfolioCashflow) {
            row['PaymentDate'] = formatter.formatDateValue(row['PaymentDate'], 'MM/YYYY');
          }
          cirtTotals = {
            CollateralLosses: formatter.formatDollarValue(
              data.PortfolioCashflowTotals.CollateralLosses
            ),
            ReductionInLiability: formatter.formatDollarValue(
              data.PortfolioCashflowTotals.ReductionInLiability
            ),
            InsurerPaidLosses: formatter.formatDollarValue(
              data.PortfolioCashflowTotals.InsurerPaidLosses
            ),
            InsurancePremium: formatter.formatDollarValue(
              data.PortfolioCashflowTotals.InsurancePremium
            ),
            NetInsuranceCashflow: formatter.formatDollarValue(
              data.PortfolioCashflowTotals.NetInsuranceCashflow
            )
          };
        }
        if (res.data.BondPortfolio) {
          bondPortfolioCashflow = formatter.formatDataInArray(
            res.data.BondPortfolio.PortfolioCashflow,
            ['Balance', 'Principal', 'ActualWriteDown', 'Interest', 'Cash'],
            ['PaymentDate'],
            ['CprRate', 'CdrRate', 'LossSeverityRate', 'DelinquencyRate', 'Rate']
          );
          for (let i = 0; i < bondPortfolioCashflow.length; i++) {
            if (i > 0 && bondPortfolioCashflow[i - 1]['Balance'] < 0.005) {
              bondPortfolioCashflow = bondPortfolioCashflow.slice(0, i);
              break;
            }
          }
        }
        handleData({
          acisPortfolioCashflow,
          totalPortfolioCashflow,
          cirtPortfolioCashflow,
          bondPortfolioCashflow,
          acisTotals,
          totalTotals,
          cirtTotals,
          res
        });
      } catch (err) {
        if (handleError) {
          handleError(err);
        } else {
          await service.log(TRACE_ERROR, err.response.data.Message, err.stack);
          ObjAlertState.set(err.response.data.Message, 3);
        }
      }
      if (showSpinner) {
        this.showSpinner = false;
      }
    },
    async getCashFlows(payload) {
      this.showTotalsPerScenario = false;
      await this.getCashFlowsFromCells([payload], {
        preRequest: this.setCashflowPreRequestData,
        postRequest: this.resetCashflowData,
        handleData: this.setCashflowData
      });
    },
    resetCashFlows() {
      this.acisPortfolioCashflow = [];
      this.cirtPortfolioCashflow = [];
      this.bondPortfolioCashflow = [];
      this.acisMiscVariables = [];
      this.cirtMiscVariables = [];
      this.bondMiscVariables = [];
    },
    async changeSelectedPortfolio(newPortfolio) {
      this.$cookies.set('portfolio', newPortfolio);
      this.showSpinner = true;
      clearResults(this);
      this.portfolioCashflow = [];
      this.selectedPortfolio = newPortfolio;
      if (this.selectedVendor != null) {
        await this.loadPortfolioScenarios(this.useGenericScenarios);
      }
      this.$store.commit('changePortfolioName', this.selectedPortfolio);
      this.resetCashFlows();
      this.showSpinner = false;
    },
    async changeSelectedVendor(newVendor) {
      this.$cookies.set('vendor', newVendor);
      this.reloadScenariosOnChange(this.useGenericScenarios);
      this.resetCashFlows();
    },
    async changeUseGenericScenarios(useGenericScenarios) {
      this.$cookies.set('useGenericScenarios', useGenericScenarios);
      this.resetCashFlows();
      if (this.selectedVendor != null) {
        this.reloadScenariosOnChange(useGenericScenarios);
      }
    },
    async changeExportScenarios(value) {
      this.$cookies.set('useExportScenarios', value);
    },
    async changeExportScenariosToCsv(value) {
      this.$cookies.set('useExportScenariosToCsv', value);
    },
    async changeCalcCashflows(useCalcCashflows) {
      this.$cookies.set('useCalcCashflows', useCalcCashflows);
    },
    async reloadScenariosOnChange(useGenericScenarios) {
      this.showSpinner = true;
      this.scenarios = new Map();
      if (this.selectedPortfolio) {
        for (let entry of this.portfolios[this.selectedPortfolio].PortfolioEntries) {
          this.$set(entry, 'Results', []);
        }
        await this.loadPortfolioScenarios(useGenericScenarios);
      }
      this.showSpinner = false;
    },
    async runPortfolio() {
      this.resetCashFlows();
      this.clearScenarios();
      this.showSpinner = true;
      let hasErrorOccured = false;
      let errors = [];
      let settlementDate = moment(this.settlementDate);
      let entryIndex = 0;
      for (let i = 0; i < this.portfolioEntries.length; i++) {
        let entry = this.portfolioEntries[i];
        let dealScenarios = this.scenarios.get(entry.DealName) || new Map();
        let requestBodyRes = [];
        let requestBody = [];
        let missingScenarios = [];
        requestBodyRes = createRequestBody(
          entry,
          i,
          settlementDate,
          this.interestRate,
          dealScenarios,
          this.scenariosNames,
          this.libor,
          this.earlyCall,
          this.modPct
        );
        requestBody = requestBodyRes[0];
        missingScenarios = requestBodyRes[1];
        let Results = new Array(this.scenariosNames.length).fill({}, 0, this.scenariosNames.length);
        let currentBalance = null;
        const yieldErr = new Set();
        try {
          let res = {};
          if (requestBody.length > 0) {
            res = await service.runPortfolio({
              Entries: requestBody
            });
          }
          let acisEntryIndex = 0;
          let cirtEntryIndex = 0;
          let bondEntryIndex = 0;
          for (let scenarioNum = 0; scenarioNum < this.scenariosNames.length; scenarioNum++) {
            let portfolioEntry = this.portfolioEntries[i];
            if (missingScenarios.includes(this.scenariosNames[scenarioNum])) {
              Results[scenarioNum] = {
                scenarioName: this.scenariosNames[scenarioNum],
                Yield: 'Missing scenario',
                RateOnLine: 'Missing scenario',
                LossOnLine: 'Missing scenario',
                ReturnOnLine: 'Missing scenario',
                CollateralLossesPct: 'Missing scenario'
              };
              continue;
            }
            let resEntry = portfolioEntry.DealName.startsWith('ACIS')
              ? res.data.AcisPortfolio.PortfolioEntries[acisEntryIndex++]
              : portfolioEntry.DealName.startsWith('CIRT')
                ? res.data.CirtPortfolio.PortfolioEntries[cirtEntryIndex++]
                : res.data.BondPortfolio.PortfolioEntries[bondEntryIndex++];
            const collateralLossesPct = formatter.formatPctValueWithoutRounding(
              resEntry.ProjectedLosses / resEntry.OriginalBalance || 0
            );
            currentBalance = resEntry.CurrentBalance;
            let value = '-----';
            if (resEntry.Yield.IsSuccessful) {
              value = formatter.formatPctValueWithoutRounding(resEntry.Yield.Value);
            } else {
              // TODO sk: remove after redesigning c++ message system
              if (
                resEntry.Yield.ErrorMessage !== "Can't compute Yield." &&
                  resEntry.Yield.ErrorMessage !== 'Too many tries in Yield calculation.' &&
                  resEntry.Yield.ErrorMessage !== 'Guess is too negative in Yield calculation.' &&
                  resEntry.Yield.ErrorMessage !== "Can't compute Spread." &&
                  resEntry.Yield.ErrorMessage !== 'Too many tries in Spread calculation.'
              ) {
                yieldErr.add(`${i + 1}: ${resEntry.Yield.ErrorMessage}`);
              }
            }
            if (
              portfolioEntry.DealName.startsWith('ACIS') ||
                portfolioEntry.DealName.startsWith('CIRT')
            ) {
              Results[scenarioNum] = {
                scenarioName: this.scenariosNames[scenarioNum],
                Yield: value,
                RateOnLine: formatter.formatPctValueWithoutRounding(
                  resEntry.LineMetrics.RateOnLine
                ),
                LossOnLine: formatter.formatPctValueWithoutRounding(
                  resEntry.LineMetrics.LossOnLine
                ),
                ReturnOnLine: formatter.formatPctValueWithoutRounding(
                  resEntry.LineMetrics.ReturnOnLine
                ),
                CollateralLossesPct: collateralLossesPct
              };
            } else {
              let spread = '-----';
              if (resEntry.Spread.IsSuccessful) {
                spread = resEntry.Spread.Value;
              } else {
                // TODO sk: remove after redesigning c++ message system
                if (
                  resEntry.Spread.ErrorMessage !== "Can't compute Yield." &&
                    resEntry.Spread.ErrorMessage !== 'Too many tries in Yield calculation.' &&
                    resEntry.Spread.ErrorMessage !== 'Guess is too negative in Yield calculation.' &&
                    resEntry.Spread.ErrorMessage !== "Can't compute Spread." &&
                    resEntry.Spread.ErrorMessage !== 'Too many tries in Spread calculation.'
                ) {
                  yieldErr.add(`${i + 1}: ${resEntry.Spread.ErrorMessage}`);
                }
              }
              Results[scenarioNum] = {
                scenarioName: this.scenariosNames[scenarioNum],
                Yield: value,
                RateOnLine:
                                     resEntry.Characteristics.Wal != null ? resEntry.Characteristics.Wal : '-----',
                LossOnLine:
                                     resEntry.Characteristics.WritedownPct != null
                                       ? formatter.formatPctValueWithoutRounding(resEntry.Characteristics.WritedownPct)
                                       : '-----',
                ReturnOnLine: spread,
                CollateralLossesPct: collateralLossesPct
              };
            }
          }
          this.$forceUpdate();
        } catch (err) {
          await service.log(TRACE_ERROR, err.response.data.Message, err.stack);
          let entries = JSON.parse(err.response.config.data).Entries;
          if (err.response.data && err.response.data.Message && err.response.data.Message.split) {
            let entryErrors = err.response.data.Message.split(', ');
            let errMsg = this.buildErrorMessage(entryErrors, entries, entryIndex, missingScenarios);
            errors.push(errMsg);
          }
        }
        if (yieldErr.size > 0) {
          const errorMessage = [...yieldErr].join('<br>');
          ObjAlertState.set(errorMessage, 3);
        }
        this.$set(entry, 'Results', Results);
        if (!entry.currentBalance || entry.currentBalance !== currentBalance) {
          this.$set(entry, 'currentBalance', currentBalance);
        }
        entryIndex++;
      }
      if (errors.length > 0) {
        ObjAlertState.set(errors.flat().join('<br>'), 3);
      }
      this.showSpinner = false;
    },
    buildErrorMessage(errors, entries, entryIndex, missingScenarios) {
      let failedEntry = this.portfolioEntries[entryIndex];
      let parsedErrors = [];
      for (let error of errors) {
        let errScenarioNum = parseInt(error.split(':')[0].split(' ')[1]) - 1;
        let existingScenarioNum = 0;
        let scenarioName = '';
        for (let scenarioNum = 0; scenarioNum < this.scenariosNames.length; scenarioNum++) {
          if (errScenarioNum === existingScenarioNum) {
            scenarioName = this.scenariosNames[scenarioNum];
            break;
          }
          if (missingScenarios.includes(this.scenariosNames[scenarioNum])) {
            continue;
          }
          existingScenarioNum++;
        }
        let msg =
                'Line ' +
                failedEntry.OrdinalNumber +
                ', Scneario  ' +
                scenarioName +
                ': ' +
                error.split(':')[1];
        parsedErrors.push(msg);
      }
      return parsedErrors.join('<br>');
    },
    async loadPortfolios() {
      this.showSpinner = true;
      try {
        let res = await service.getPortfolios();
        if (res.status === 200) {
          this.portfolios = {};
          this.portfolios = res.data;
          this.selectedPortfolio = this.portfolios.hasOwnProperty(this.selectedPortfolio)
            ? this.selectedPortfolio
            : this.portfolios[Object.keys(this.portfolios)[0]].Name;
          this.portfolioCashflow = [];
          this.$forceUpdate();
        } else {
          ObjAlertState.set('No portfolios found.', 3);
        }
      } catch (err) {
        ObjAlertState.set(err.response.data, 3);
      }
      this.showSpinner = false;
    },
    async loadPortfolioScenarios(useGenericScenarios) {
      this.showSpinner = true;
      let scenarioNamesSet = new Set();
      let selectVendorToPass = this.selectedVendor === 'All' ? null : this.selectedVendor;
      let portfolioDeals = new Set(this.portfolioEntries.map(e => e.DealName));
      if (useGenericScenarios) {
        let scenarios = await getScenarios(selectVendorToPass, 'Default', 'Default');
        this.flatScenarios = scenarios.map(({ Id, ScenarioName, DealName, Vendor }) => ({
          id: Id,
          name: ScenarioName,
          dealName: DealName,
          vendor: Vendor,
          hidden: Boolean(this.savedScenariosToHide[ScenarioName])
        }));

        for (let dealName of portfolioDeals) {
          this.scenarios.set(dealName, new Map());
          let map = this.scenarios.get(dealName);
          for (let scenario of scenarios) {
            map.set(scenario.ScenarioName, scenario);
            if (!this.savedScenariosToHide[scenario.ScenarioName]) {
              scenarioNamesSet.add(scenario.ScenarioName);
            }
          }
        }
      } else {
        // let dealTuples = await prepareDealNames(this.portfolioEntries)
        try {
          let scenariosHash = {};
          let res = await service.getPortfolioScenarios(
            this.portfolios[this.selectedPortfolio].Id,
            selectVendorToPass
          );
          // TODO: for what reason?
          delete (res.data['']);

          for (let dealName of Object.keys(res.data)) {
            this.scenarios.set(dealName, new Map());
            let map = this.scenarios.get(dealName);
            for (let scenario of res.data[dealName]) {
              const isScenarioHidden = Boolean(this.savedScenariosToHide[scenario.ScenarioName]);
              map.set(scenario.ScenarioName, scenario);
              if (!isScenarioHidden) {
                scenarioNamesSet.add(scenario.ScenarioName);
              }
              if (!scenariosHash[scenario.ScenarioName]) {
                scenariosHash[scenario.ScenarioName] = {
                  id: scenario.Id,
                  name: scenario.ScenarioName,
                  dealName: scenario.DealName,
                  vendor: scenario.Vendor,
                  hidden: isScenarioHidden
                };
              }
            }
          }
          this.flatScenarios = Object.values(scenariosHash);
          // let map = this.scenarios.get(dealName)
          // for(let scenario of scenarios) {
          //   map.set(scenario.ScenarioName, scenario)
          //   scenarioNamesSet.add(scenario.ScenarioName)
          // }
        } catch (err) {
          await service.log(
            TRACE_ERROR,
            err.response.data ? err.response.data.Message : err.response.data,
            err.stack
          );
          ObjAlertState.set(err.response.data, 3);
        }
        // for(let dealTuple of dealTuples){
        //   let dealName = dealTuple.DealName
        //   try {
        //     let dealNameToPass = dealTuple.DealName
        //     let parentDealNameToPass = dealTuple.ParentDealName
        //     let scenarios = await getScenarios(selectVendorToPass, dealNameToPass, parentDealNameToPass)
        //     this.scenarios.set(dealName, new Map());
        //     let map = this.scenarios.get(dealName)
        //     for(let scenario of scenarios) {
        //       map.set(scenario.ScenarioName, scenario)
        //       scenarioNamesSet.add(scenario.ScenarioName)
        //     }
        //   } catch (err) {
        //     console.log(err)
        //     this.$refs.alert.showAlert("danger", err.response.data);
        //   }
        // }
      }
      if (scenarioNamesSet.size > 0) {
        this.scenariosNames = Array.from(scenarioNamesSet).sort(naturalSort);
      } else {
        this.scenariosNames = [];
      }
      if (this.scenarios.size > 0) {
        let size = 0;
        let iterator = this.scenarios.values();
        for (
          let nextValue = iterator.next();
          nextValue.done !== true;
          nextValue = iterator.next()
        ) {
          if (nextValue.value.length > size) ;
          size = nextValue.value.length;
        }
        this.scenariosSize = size;
      } else {
        this.scenariosSize = 0;
      }
      let iterator = this.scenarios.values();
      for (let nextValue = iterator.next(); nextValue.done !== true; nextValue = iterator.next()) {
        if (nextValue.value.length < this.scenariosSize) ;
        nextValue.value.length = this.scenariosSize;
      }
      this.showSpinner = false;
    },
    exportToExcel() {
      import('exceljs').then(({ Workbook: ExcelWorkbook }) => {
        let portfolio = this.portfolios[this.selectedPortfolio];
        var workbook = new ExcelWorkbook();
        let roiSheetName = portfolio.PortfolioType === 'Reinsurance' ? 'ROI' : 'Yield';
        let rateSheetName = portfolio.PortfolioType === 'Reinsurance' ? 'Rate on line' : 'WAL';
        let lossSheetName = portfolio.PortfolioType === 'Reinsurance' ? 'Loss on line' : 'Writedown';
        let returnSheetName = portfolio.PortfolioType === 'Reinsurance' ? 'Margin on line' : 'Spread';
        const collateralLossesSheetName = 'Ref Pool Loss Pct';
        var roiSheet = workbook.addWorksheet(roiSheetName);
        var rateOLSheet = workbook.addWorksheet(rateSheetName);
        var lossOLSheet = workbook.addWorksheet(lossSheetName);
        var returnOLSheet = workbook.addWorksheet(returnSheetName);
        const collateralLossesSheet = workbook.addWorksheet(collateralLossesSheetName);
        let contractColumnName =
          portfolio.PortfolioType === 'Reinsurance' ? 'Initial Limit ($)' : 'Balance ($)';
        let collColumnName =
          portfolio.PortfolioType === 'Reinsurance' ? 'Collateral (%)' : 'Price ($)';
        let balanceColumnName =
          portfolio.PortfolioType === 'Reinsurance' ? 'Current Limit ($)' : 'Current Balance ($)';
        let columns = [
          { header: 'Deal Name', key: 'dealName' },
          { header: 'Bond Name', key: 'bondName' },
          { header: contractColumnName, key: 'contract' },
          { header: balanceColumnName, key: 'currentBalance' },
          { header: collColumnName, key: 'collateral' }
        ];
        for (let scenarioName of this.scenariosNames) {
          columns.push({ header: scenarioName, key: scenarioName });
        }
        roiSheet.columns = columns;
        rateOLSheet.columns = columns;
        lossOLSheet.columns = columns;
        returnOLSheet.columns = columns;
        collateralLossesSheet.columns = columns;
        let fun = portfolio.PortfolioType === 'Reinsurance' ? this.reinruranceFun : this.bondsFun;
        for (let entry of this.portfolioEntries) {
          let coll = portfolio.PortfolioType === 'Reinsurance' ? entry.Margin / 100 : entry.Margin;
          const prefix = [
            entry.DealName,
            entry.BondName,
            Number(entry.OwnedFaceAmt),
            entry.currentBalance,
            coll
          ];
          let roi = [];
          let rateOnLine = [];
          let lossOnLine = [];
          let returnOnLine = [];
          let collateralLossesPct = [];
          for (let result of entry.Results) {
            let rroi, rol, lol, retol, collLossPct;
            [rroi, rol, lol, retol, collLossPct] = fun(result);
            roi.push(rroi);
            rateOnLine.push(rol);
            lossOnLine.push(lol);
            returnOnLine.push(retol);
            collateralLossesPct.push(collLossPct);
          }
          roiSheet.addRow(prefix.concat(roi));
          rateOLSheet.addRow(prefix.concat(rateOnLine));
          lossOLSheet.addRow(prefix.concat(lossOnLine));
          returnOLSheet.addRow(prefix.concat(returnOnLine));
          collateralLossesSheet.addRow(prefix.concat(collateralLossesPct));
        }
        let sheets = [roiSheet, rateOLSheet, lossOLSheet, returnOLSheet, collateralLossesSheet];
        if (portfolio.PortfolioType === 'Reinsurance') {
          formatColumn(sheets, [3, 4], '#,##0.00000000');
          formatColumn(sheets, [5], '0.00000000%', this.scenariosNames.length);
          formatColumn([collateralLossesSheet], [6], '0.00000000%', this.scenariosNames.length);
        } else {
          formatColumn(sheets, [3, 4, 5], '#,##0.00000000');
          formatColumn(
            [roiSheet, lossOLSheet, collateralLossesSheet],
            [6],
            '0.00000000%',
            this.scenariosNames.length
          );
        }
        let workBookName =
          this.selectedPortfolio +
          '_AsOf_' +
          moment(this.settlementDate).format('MM/DD/YYYY') +
          '_InterestRate_' +
          this.interestRate +
          '.xlsx';
        workbook.xlsx
          .writeBuffer()
          .then(buffer => FileSaver.saveAs(new Blob([buffer]), workBookName))
          .catch(err => console.log('Error writing excel export', err));
      });
    },
    reinruranceFun(result) {
      let res = [];
      let yld = parseFloat(result.Yield);
      if (!isNaN(yld)) {
        res.push(yld / 100);
      } else {
        res.push(result.Yield);
      }
      let rateOL = parseFloat(result.RateOnLine);
      if (!isNaN(rateOL)) {
        res.push(rateOL / 100);
      } else {
        res.push(result.RateOnLine);
      }
      let lossOL = parseFloat(result.LossOnLine);
      if (!isNaN(lossOL)) {
        res.push(lossOL / 100);
      } else {
        res.push(result.LossOnLine);
      }
      let returnOL = parseFloat(result.ReturnOnLine);
      if (!isNaN(returnOL)) {
        res.push(returnOL / 100);
      } else {
        res.push(result.ReturnOnLine);
      }
      const collateralLossesPct = parseFloat(result.CollateralLossesPct);
      if (!isNaN(collateralLossesPct)) {
        res.push(collateralLossesPct / 100);
      } else {
        res.push(result.CollateralLossesPct);
      }
      return res;
    },
    bondsFun(result) {
      let res = [];
      let yld = parseFloat(result.Yield);
      if (!isNaN(yld)) {
        res.push(yld / 100);
      } else {
        res.push(result.Yield);
      }
      let rateOL = parseFloat(result.RateOnLine);
      if (!isNaN(rateOL)) {
        res.push(rateOL);
      } else {
        res.push(result.RateOnLine);
      }
      let lossOL = parseFloat(result.LossOnLine);
      if (!isNaN(lossOL)) {
        res.push(lossOL / 100);
      } else {
        res.push(result.LossOnLine);
      }
      let retOL = parseFloat(result.ReturnOnLine);
      if (!isNaN(retOL)) {
        res.push(retOL);
      } else {
        res.push(result.ReturnOnLine);
      }
      const collateralLossesPct = parseFloat(result.CollateralLossesPct);
      if (!isNaN(collateralLossesPct)) {
        res.push(collateralLossesPct / 100);
      } else {
        res.push(result.CollateralLossesPct);
      }
      return res;
    },
    exportPerScenarioTableToExcel(dealType, refName) {
      let matrix = this.$refs[refName].toMatrix();
      return excelSupport.exportTotalCashFlowToExcel(
        this.$store.getters.username,
        this.settlementDate,
        this.runDate,
        this.selectedScenario,
        this.selectedPortfolio,
        dealType,
        matrix
      );
    },
    exportCashflowToExcel() {
      let scenario = this.selectedScenario;
      let entry = this.selectedEntry;
      let matrix = [];
      if (entry.DealName.startsWith('ACIS')) {
        matrix = this.$refs.acisCashflow.toMatrix();
      } else if (entry.DealName.startsWith('CIRT')) {
        matrix = this.$refs.cirtCashflow.toMatrix();
      } else {
        matrix = this.$refs.bondCashflow.toMatrix();
      }
      return excelSupport.exportCashflowToExcel(
        this.$store.getters.username,
        entry.DealName,
        !entry.DealName.startsWith('CIRT') ? entry.BondName : null,
        this.settlementDate,
        this.runDate,
        this.selectedScenario,
        matrix
      );
    },
    async clearScenarios() {
      let entryIndex = 0;
      for (let i = 0; i < this.portfolioEntries.length; i++) {
        let entry = this.portfolioEntries[i];
        let Results = new Array(this.scenariosNames.length).fill({}, 0, this.scenariosNames.length);
        for (let scenarioNum = 0; scenarioNum < this.scenariosNames.length; scenarioNum++) {
          Results[scenarioNum] = {
            scenarioName: this.scenariosNames[scenarioNum],
            Yield: '',
            RateOnLine: '',
            LossOnLine: '',
            ReturnOnLine: ''
          };
        }
        this.$forceUpdate();
        this.$set(entry, 'Results', Results);
        entryIndex++;
      }
    },
    onHideScenariosSelected(selected) {
      const selectedHash = selected.reduce((acc, name) => ({ ...acc, [name]: true }), {});
      this.savedScenariosToHide = selectedHash;
      this.flatScenarios = this.flatScenarios
        .reduce((acc, scenario) => ([...acc, { ...scenario, hidden: !!selectedHash[scenario.name] }]), []);
      this.scenariosNames = this.flatScenarios
        .reduce((acc, { name, hidden }) => (hidden ? acc : [...acc, name]), [])
        .sort(naturalSort);
      this.$cookies.set(SELECTED_SCENARIOS, JSON.stringify(selected));
      this.clearScenarios();
    },
    log(data, text = '~') {
    },
    formatInteger(value) {
      return formatter.formatAsNumber(value, 0);
    }
  },
  components: {
    Datepicker,
    AcisCashflow,
    CirtCashflow,
    BondCashflow,
    VendorGridEntry,
    HideScenarios,
  },
  async beforeRouteLeave(to, from, next) {
    let proceedRouting = true;
    if (this.unsavedChanges) {
      const shouldSave = window.confirm('You have unsaved changes! Do you want to save them?');
      if (shouldSave) {
        proceedRouting = await this.save();
      }
    }
    next(proceedRouting);
  }
};

function formatColumn(sheets, columnIndexes, format, scenariosCount = null) {
  for (let i = 0; i < sheets.length; i++) {
    if (scenariosCount == null) {
      for (let index of columnIndexes) {
        sheets[i].getColumn(index).eachCell(function (cell, rowNumber) {
          cell.numFmt = format;
        });
      }
    } else {
      for (let j = 0; j < scenariosCount; j++) {
        sheets[i].getColumn(columnIndexes[0] + j).eachCell(function (cell, rowNumber) {
          cell.numFmt = format;
        });
      }
    }
  }
}

async function prepareDealNames(portfolioEntries) {
  let result = [];
  let portfolioDeals = new Set(portfolioEntries.map(e => e.DealName));
  for (let deal of portfolioDeals) {
    let tuple = {
      DealName: deal,
      ParentDealName: null
    };
    // if(deal.startsWith("ACIS")){
    //   let dealRes = await service.getDealDetails(deal)
    //   if(dealRes.status == 200){
    //     tuple.ParentDealName = dealRes.data.ParentDealName
    //   }
    // }
    result.push(tuple);
  }
  return result;
}

async function getScenarios(selectedVendor, dealName, parentDealName) {
  let res;
  if (selectedVendor !== 'MIAC') {
    try {
      res = await service.getUserScenarios(dealName, selectedVendor);
    } catch (err) {
      if (err.response.status === 404 && parentDealName != null) {
        try {
          res = await service.getUserScenarios(parentDealName, selectedVendor);
        } catch (err) {
          await service.log(TRACE_ERROR, err.response.data.Message, err.stack);
          if (err.response.status === 404) {
            return [];
          }
          throw err;
        }
      } else if (err.response.status === 404) {
        return [];
      } else {
        throw err;
      }
    }
  } else {
    try {
      res = await service.getUserCollateralCashflows(
        dealName,
        selectedVendor /* settlement date */
      );
    } catch (err) {
      await service.log(TRACE_ERROR, err.response.data.Message, err.stack);
      if (err.response.status === 404 && parentDealName != null) {
        try {
          res = await service.getUserCollateralCashflows(
            parentDealName,
            selectedVendor /* settlement date */
          );
        } catch (err) {
          await service.log(TRACE_ERROR, err.response.data.Message, err.stack);
          if (err.response.status === 404) {
            return [];
          }
          throw err;
        }
      } else if (err.response.status === 404) {
        return [];
      } else {
        throw err;
      }
    }
  }
  return res.data;
}

function createRequestBody(
  entry,
  entryNo,
  settlementDate,
  interestRate,
  dealScenarios,
  scenarioNames,
  libor,
  earlyCall,
  modPct
) {
  let missingScenarios = [];
  let requestBody = [];
  let ownedFaceAmt = Number(entry.OwnedFaceAmt);
  // if(entry.DealName.startsWith("CIRT")){
  //   let stDate = moment(this.settlementDate)
  //   let activityMonth = moment()
  //       .year(stDate.year())
  //       .month(stDate.month() - 2)
  //       .date(25);
  //   settlementDate = activityMonth;
  // }
  for (const scenarioName of scenarioNames) {
    if (!dealScenarios.has(scenarioName)) {
      missingScenarios.push(scenarioName);
      continue;
    }
    let scenario = dealScenarios.get(scenarioName);
    let body = {
      SettlementDate: settlementDate.format('YYYYMMDD'),
      DealName: entry.DealName,
      BondName: entry.BondName || null,
      OwnedFaceAmt: ownedFaceAmt,
      Margin: entry.Margin / 100,
      InterestRate: interestRate / 100,
      Libor: convertToPctArray(libor),
      Price: entry.Margin,
      Balance: ownedFaceAmt,
      Cancellation: earlyCall,
      // "CancellationDate": entry.CancellationDate || null,
      CleanupCall: earlyCall,
      ModPct: modPct
    };
    if (scenario.hasOwnProperty('CollateralCashflow')) {
      Object.assign(body, {
        UserCollateralCashflow: scenario.CollateralCashflow
      });
    } else {
      Object.assign(body, {
        Cpr: convertToPctArray(scenario.Cpr),
        Cdr: convertToPctArray(scenario.Cdr),
        LossSeverity: convertToPctArray(scenario.LossSeverity),
        Delinquency: convertToPctArray(scenario.Delinquency),
        Libor: convertToPctArray(libor)
      });
    }
    requestBody.push(body);
  }
  return [requestBody, missingScenarios];
}

function clearResults(root) {
  root.interestRate = 0.0;
  root.libor = 0.0;
}

function setDataFromStore(root) {
  root.interestRate = root.$store.getters.portfolioResult.interestRate || 0.0;
  root.libor = root.$store.getters.portfolioResult.libor || 0.0;
}
</script>
<style lang="scss">
.w {
  &-5 {
    width: 5% !important;
  }

  &-6 {
    width: 6% !important;
  }
}
</style>

<style lang="scss" scoped>
%parameters-column {
  vertical-align: top;
  display: inline-block;
}
.parameters-label {
  @extend %parameters-column;
  width: auto;
  min-width: 7rem;
  text-overflow: ellipsis;
  white-space: nowrap;
  vertical-align: text-top;
}
.parameters-content {
  @extend %parameters-column;
  width: 7rem;
  min-width: 7rem;
}
.form-row {
  margin-left: 0px;
  margin-right: 0px;
}
#portfolio_select {
  min-width: 15rem;
}
#vendor_select {
  min-width: 15rem;
}
.color_hover:hover {
  background-color: rgba(23, 162, 184, 0.3);
  cursor: pointer;
}

.content-width {
  width: fit-content;
  width: -moz-fit-content;
}
</style>
